"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeUserRoles = exports.isScheduleValid = exports.getTimezone = exports.getListSummaryText = exports.getFilters = exports.getFilterIdList = exports.getDaysLeftPastDate = exports.getDateSummaryText = exports.getDateByNumberOfDaysAgo = exports.generateEmailTypes = exports.generateEmailTones = exports.generateEmailLength = exports.generateEmailGoals = exports.addInlineStyles = exports.TOOLTIP_MESSAGE = exports.STICKY_MESSAGE = exports.PREVIEW_TEXT_LENGTH = exports.HEADER_BUTTONS = exports.EXPIRING_CAMPAIGN_MESSAGE = exports.DYNAMIC_FETCHING_PARAMS = exports.DISABLED_PROJECT_PARAMS = exports.DEFAULT_LAST_ACTIVITY_DAYS_AGO = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _SimpleFilterSelector = _interopRequireDefault(require("../overview/filters/SimpleFilterSelector"));

var _DateFilterSelector = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/DateFilterSelector"));

var _Filters = require("@insided/deprecated-control/UserOverview/Filters");

var _dateFormatting = _interopRequireDefault(require("@insided/shared/utils/dateFormatting"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var DEFAULT_LAST_ACTIVITY_DAYS_AGO = 365;
exports.DEFAULT_LAST_ACTIVITY_DAYS_AGO = DEFAULT_LAST_ACTIVITY_DAYS_AGO;

var getListSummaryText = function getListSummaryText(items, filter) {
  if (items && (filter === null || filter === void 0 ? void 0 : filter.length) > 0) {
    var _items$find;

    var firstItem = (_items$find = items.find(function (r) {
      return r.value === filter[0];
    })) === null || _items$find === void 0 ? void 0 : _items$find.name;
    return (0, _preact.h)("span", {
      className: "filter-summary-bold"
    }, firstItem, filter.length > 1 ? " +".concat(filter.length - 1) : '');
  }

  return null;
};

exports.getListSummaryText = getListSummaryText;

var getDateSummaryText = function getDateSummaryText(filter) {
  if (!filter) {
    return null;
  }

  var formatDate = function formatDate(date) {
    return (0, _dateFormatting.default)(new Date(date).getTime() / 1000 | 0);
  };

  var condition = filter.condition,
      data = filter.data;
  var value;

  if (condition === 'lt') {
    value = "Less than ".concat(data, " day").concat(data !== 1 ? 's' : '', " ago");
  } else if (condition === 'gt') {
    value = "More than ".concat(data, " day").concat(data !== 1 ? 's' : '', " ago");
  } else if (condition === 'eq') {
    value = "On ".concat(formatDate(data));
  } else if (condition === 'from') {
    value = "After ".concat(formatDate(data));
  } else if (condition === 'to') {
    value = "Before ".concat(formatDate(data));
  } else {
    var from = data.from,
        to = data.to;
    value = "Between ".concat(formatDate(from), " and ").concat(formatDate(to));
  }

  return (0, _preact.h)("span", {
    className: "filter-summary-bold"
  }, value);
};

exports.getDateSummaryText = getDateSummaryText;

var normalizeUserRoles = function normalizeUserRoles(roles) {
  return roles.map(function (role) {
    return {
      id: role.id.toString(),
      name: role.label,
      label: role.label,
      value: role.name
    };
  });
};

exports.normalizeUserRoles = normalizeUserRoles;

var getFilters = function getFilters(roleMap, groups) {
  return [_SimpleFilterSelector.default.create({
    id: 'mainRoles',
    name: 'Primary role',
    isSearchable: true,
    items: (0, _toConsumableArray2.default)(roleMap.mainRoles)
  }), _SimpleFilterSelector.default.create({
    id: 'customRoles',
    name: 'Custom role',
    isSearchable: true,
    items: (0, _toConsumableArray2.default)(roleMap.customRoles || [])
  }), _SimpleFilterSelector.default.create({
    id: 'groups',
    name: 'Groups',
    isSearchable: true,
    items: groups || []
  }), _DateFilterSelector.default.create({
    id: 'joinDate',
    name: 'Registration date',
    items: _Filters.dateSelectorItems
  }), _DateFilterSelector.default.create({
    id: 'lastActivity',
    name: 'Last activity date',
    items: _Filters.dateSelectorItems
  })];
};

exports.getFilters = getFilters;

var getFilterIdList = function getFilterIdList(filterList, filterMap) {
  var idList = [];
  filterList.forEach(function (filterValue) {
    var filterObj = filterMap.find(function (f) {
      return f.value === filterValue;
    });

    if (filterObj) {
      idList.push(filterObj.id.toString());
    }
  });
  return idList;
};

exports.getFilterIdList = getFilterIdList;

var getTimezone = function getTimezone(timezone, timezoneList) {
  var foundTimezone = timezoneList.find(function (tz) {
    return tz.value === timezone;
  });

  if (foundTimezone) {
    return foundTimezone;
  }

  return {
    title: '',
    value: ''
  };
};

exports.getTimezone = getTimezone;

var addInlineStyles = function addInlineStyles(content) {
  var element = document.createElement('div');
  element.innerHTML = content.trim();
  var imgElements = element.querySelectorAll('img');
  imgElements.forEach(function (img) {
    if (!img.style.maxWidth) {
      img.style.maxWidth = '100%';
    }
  });
  var htmlStr = element.outerHTML; // remove wrapper div tag

  return htmlStr.substring(5, htmlStr.length - 6);
};

exports.addInlineStyles = addInlineStyles;

var isScheduleValid = function isScheduleValid(schedule, now) {
  var scheduledDate = new Date("".concat(schedule.date, " ").concat(schedule.time, " ").concat(schedule.timeZone.offset));
  var expectedMinimumTimeDiff = 20;
  var timeDiffInminutes = (scheduledDate.getTime() - now.getTime()) / (1000 * 60);
  return timeDiffInminutes >= expectedMinimumTimeDiff;
};

exports.isScheduleValid = isScheduleValid;
var PREVIEW_TEXT_LENGTH = 150;
exports.PREVIEW_TEXT_LENGTH = PREVIEW_TEXT_LENGTH;

var getDaysLeftPastDate = function getDaysLeftPastDate(date) {
  var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds

  var firstDate = new Date(date);
  var secondDate = new Date();
  return Math.round(Math.abs((secondDate.getTime() - firstDate.getTime()) / oneDay));
};

exports.getDaysLeftPastDate = getDaysLeftPastDate;

var getDateByNumberOfDaysAgo = function getDateByNumberOfDaysAgo(daysLeft) {
  var lastActivityDaysAgo = daysLeft !== null && daysLeft !== void 0 ? daysLeft : DEFAULT_LAST_ACTIVITY_DAYS_AGO;
  var date = new Date();
  date.setDate(date.getDate() - lastActivityDaysAgo);
  return date.toISOString();
};

exports.getDateByNumberOfDaysAgo = getDateByNumberOfDaysAgo;
var generateEmailTypes = [{
  title: 'Onboarding new users',
  prompt: 'Onboarding new users, help them understand how the community works, what can be done and what they can get out of it'
}, {
  title: 'Re-engaging inactive users',
  prompt: 'Re-engaging an inactive users by driving them back to the community, reminding them why the community is a useful tool and that they should stick around'
}];
exports.generateEmailTypes = generateEmailTypes;
var generateEmailGoals = [{
  name: 'Share customer benefits',
  value: '1',
  prompt: 'Share benefits of being part of our community'
}, {
  name: 'Create a first topic',
  value: '2',
  prompt: 'Motivate the users to create their first topic and engage with other community users'
}, {
  name: 'Share a first idea',
  value: '3',
  prompt: 'Motivate the user to share their first idea and help the company to improve the product or share feedback'
}, {
  name: 'Answer unanswered questions',
  value: '4',
  prompt: "Motivate the user to help another user by answering a question. Add a link to the unanswered questions page (".concat((0, _globals.default)('communityUrl'), "/activity/unanswered)")
}, {
  name: 'Join a group',
  value: '5',
  prompt: "Motivate the user to join a group and be part of a family. Add a link to the groups overview page (".concat((0, _globals.default)('communityUrl'), "/groups)")
}, {
  name: 'Join an event',
  value: '6',
  prompt: "Motivate the user to join an event. Add a link to the community event page (".concat((0, _globals.default)('communityUrl'), "/events)")
}];
exports.generateEmailGoals = generateEmailGoals;
var generateEmailTones = [{
  title: 'Professional'
}, {
  title: 'Casual'
}, {
  title: 'Straightforward'
}, {
  title: 'Confident'
}, {
  title: 'Friendly'
}, {
  title: 'Witty'
}];
exports.generateEmailTones = generateEmailTones;
var generateEmailLength = [{
  title: 'Short',
  prompt: 'Short (max. 100 words)'
}, {
  title: 'Medium',
  prompt: 'Medium (max of 200 words)'
}, {
  title: 'Long',
  prompt: 'Long (max. of 300 words)'
}];
exports.generateEmailLength = generateEmailLength;
var TOOLTIP_MESSAGE = {
  delivered_count: 'emails delivered',
  opened_count: 'of opens',
  clicked_count: 'recipients clicked on any link',
  spam_count: 'emails in arrived in junk folders',
  unsubscribed_count: 'recipients clicked on the unsubscribe link'
};
exports.TOOLTIP_MESSAGE = TOOLTIP_MESSAGE;
var HEADER_BUTTONS = [(0, _preact.h)("a", {
  href: (0, _absoluteUrlRuntime.resolveUrl)("/email/email-template/1"),
  key: "customise",
  "data-track-type": "click",
  "data-element-name": "Email template customise link"
}, (0, _preact.h)(_Button.default, {
  title: "Customise theme",
  size: "medium",
  className: "qa-customise-email-template"
})), (0, _preact.h)("a", {
  href: (0, _absoluteUrlRuntime.resolveUrl)("/email/new/email-campaign"),
  key: "add",
  "data-track-type": "click",
  "data-element-name": "Add new email campaign link"
}, (0, _preact.h)(_Button.default, {
  title: "Add email campaign",
  variant: "brand",
  size: "medium",
  className: "qa-add-email-campaign"
}))];
exports.HEADER_BUTTONS = HEADER_BUTTONS;
var DYNAMIC_FETCHING_PARAMS = {
  endpoint: '/emailCampaign/list',
  dataKey: 'emailCampaigns',
  defaultFilteringOptions: {
    filters: {
      status: ['draft', 'scheduled', 'completed', 'active', 'executing'],
      search: ''
    }
  }
};
exports.DYNAMIC_FETCHING_PARAMS = DYNAMIC_FETCHING_PARAMS;
var DISABLED_PROJECT_PARAMS = {
  withPagination: {
    page: 1,
    pageSize: 1
  },
  dataSource: function () {
    var _dataSource = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.resolve({
                data: [],
                total: 0
              });

            case 2:
              return _context.abrupt("return", _context.sent);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function dataSource() {
      return _dataSource.apply(this, arguments);
    }

    return dataSource;
  }()
};
exports.DISABLED_PROJECT_PARAMS = DISABLED_PROJECT_PARAMS;
var STICKY_MESSAGE = (0, _preact.h)("div", null, "Before you can start sending email campaigns, you need to set a webmaster email. Please go to the", ' ', (0, _preact.h)("a", {
  href: (0, _absoluteUrlRuntime.resolveUrl)("/webmasterManagement"),
  "data-track-type": "click",
  "data-element-name": "Webmaster Email link"
}, "Webmaster Email"), ' ', "page to verify and enable a valid email address.");
exports.STICKY_MESSAGE = STICKY_MESSAGE;
var EXPIRING_CAMPAIGN_MESSAGE = (0, _preact.h)("div", null, "You have one or more automated email campaigns that will expire within the next 30 days. To continue sending these email campaigns, you need to archive them, duplicate them, make any necessary improvements, and activate these automated email campaigns.", ' ', (0, _preact.h)("a", {
  href: "https://communities.gainsight.com/email-campaigns-66/sending-an-automated-email-campaign-22249",
  target: "_blank",
  rel: "noreferrer"
}, "Read more"), ".");
exports.EXPIRING_CAMPAIGN_MESSAGE = EXPIRING_CAMPAIGN_MESSAGE;